// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import API_BASE_URL from '../config';
// import MatchesList from './MatchesList';
// import UpgradeModal from '../components/UpgradeModal';
// import useAccess from '../hooks/useAccess';
// import { 
//   Paper, 
//   Box, 
//   Typography, 
//   Button, 
//   Stack, 
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Fade,
//   Card,
//   CardContent,
//   useTheme,
//   alpha
// } from '@mui/material';
// import {
//   WomanRounded,
//   ManRounded,
//   Favorite,
//   ArrowUpward
// } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';

// // Styled Components
// const StyledPaper = styled(Paper)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`,
//   borderRadius: theme.spacing(3),
//   padding: theme.spacing(4),
//   position: 'relative',
//   overflow: 'hidden',
//   boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
// }));

// const AgeGroupButton = styled(Button)(({ theme, selected }) => ({
//   borderRadius: theme.spacing(4),
//   padding: theme.spacing(1, 3),
//   transition: 'all 0.3s ease',
//   margin: theme.spacing(0.5),
//   backgroundColor: selected ? theme.palette.primary.main : 'transparent',
//   color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
//   border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
//   '&:hover': {
//     transform: 'translateY(-2px)',
//     backgroundColor: selected ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.1),
//   },
// }));

// const GenderSection = styled(Box)(({ theme }) => ({
//   background: alpha(theme.palette.background.paper, 0.6),
//   borderRadius: theme.spacing(2),
//   padding: theme.spacing(3),
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-5px)',
//     boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
//   },
// }));

// const FindPartner = () => {
//   const theme = useTheme();
//   const { role, isPremium, loading: accessLoading } = useAccess();
//   const [selectedAgeGroup, setSelectedAgeGroup] = useState('');
//   const [matches, setMatches] = useState({ male: [], female: [] });
//   const [loading, setLoading] = useState({ male: false, female: false });
//   const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
//   const [remainingSearches, setRemainingSearches] = useState(null);
//   const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

//   const userRole = role == null ? null : Number(role);

//   const ageGroups = [
//     { label: '18-22', min: 18, max: 22 },
//     { label: '23-26', min: 23, max: 26 },
//     { label: '27-31', min: 27, max: 31 },
//     { label: '32-36', min: 32, max: 36 },
//     { label: '37-41', min: 37, max: 41 },
//     { label: '42-80', min: 42, max: 80 },
//   ];

//   // Add this function to fetch remaining searches
//   const fetchRemainingSearches = async (uid) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/user/remaining-searches`, {
//         params: { uid },
//         withCredentials: true
//       });
//       setRemainingSearches(3 - response.data.searchCount);
//     } catch (error) {
//       console.error('Error fetching remaining searches:', error);
//     }
//   };
//   useEffect(() => {
//     const init = async () => {
//       try {
//         const userUid = localStorage.getItem('uid');
//         if (!userUid) {
//           console.log('No user logged in');
//           window.location.href = './login';
//           return;
//         }

//         await fetchRemainingSearches(userUid);
//       } catch (error) {
//         console.error('Failed to fetch user details:', error);
//         if (error.response && error.response.status === 401) {
//           window.location.href = './login';
//         }
//       }
//     };

//     init();
//   }, []);

//   useEffect(() => {
//     if (accessLoading) return;
//     if (remainingSearches == null) return;
//     if (!isPremium && remainingSearches <= 0 && userRole !== 1) {
//       setShowUpgradeDialog(true);
//     }
//   }, [accessLoading, isPremium, remainingSearches, userRole]);

//   const searchMatches = async (gender, ageGroup) => {
//     const userUid = localStorage.getItem('uid');
//     await fetchRemainingSearches(userUid);
//     if (!isPremium && remainingSearches <= 0 && userRole !== 1) {
//       setShowUpgradeDialog(true);
//       return;
//     }

//     setLoading(prev => ({ ...prev, [gender.toLowerCase()]: true }));
//     try {
//       const response = await axios.get(`${API_BASE_URL}/find-match`, {
//         params: { 
//           gender: gender === 'Male' ? 'Male' : 'Female', 
//           minAge: ageGroup.min, 
//           maxAge: ageGroup.max 
//         },
//         withCredentials: true
//       });
//       setMatches(prev => ({ ...prev, [gender.toLowerCase()]: response.data }));
//     } catch (error) {
//       console.error('Error fetching matches:', error);
//       if (error.response && error.response.status === 401) {
//         window.location.href = './login';
//       }
//     }
//     setLoading(prev => ({ ...prev, [gender.toLowerCase()]: false }));
//   };

//   const handleAgeGroupSelect = (group) => {
//     setSelectedAgeGroup(group.label);
//     if (userRole === 0 && !isPremium && remainingSearches == 0) {
//       setShowUpgradeDialog(true);
//       return;
//     }
//     searchMatches('Male', group);
//     searchMatches('Female', group);
//   };

//   return (
//     <Box>
//       <Fade in timeout={1000}>
//         <StyledPaper>
//           <Box sx={{ textAlign: 'center', mb: 6 }}>
//             <Typography 
//               variant="h4" 
//               gutterBottom 
//               sx={{ 
//                 fontWeight: 700,
//                 background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 color: 'transparent',
//               }}
//             >
//               Find Your Perfect Match
//             </Typography>
//             <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
//               Discover compatible partners in your preferred age group
//             </Typography>
//             {userRole === 0 && !isPremium && (
//   <Typography 
//     variant="body2" 
//     color="textSecondary" 
//     sx={{ mb: 2, textAlign: 'center' }}
//   >
//     {remainingSearches > 0 
//       ? `Searches remaining: ${remainingSearches}` 
//       : 'You have used all your free searches'}
//   </Typography>
// )}
//             {(userRole === 0 || userRole === 2) && (
//               <Typography 
//                 variant="body2" 
//                 color="textSecondary" 
//                 sx={{ mb: 2, textAlign: 'center' }}
//               >
//                 {!isPremium 
//                   ? 'Upgrade your account to find matches' 
//                   : `Subscription Status: ${isPremium ? 'Premium' : 'Basic'}`}
//               </Typography>
//             )}
//           </Box>

//           {((userRole === 0 || userRole === 2) && !isPremium && remainingSearches === 0) ? (
//             <Card sx={{ maxWidth: 400, mx: 'auto', textAlign: 'center' }}>
//               <CardContent>
//                 <Favorite sx={{ fontSize: 60, color: theme.palette.error.light, mb: 2 }} />
//                 <Typography variant="h5" gutterBottom>
//                   Premium Feature
//                 </Typography>
//                 <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
//                   Unlock access to our advanced matching system by upgrading your account.
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   size="large"
//                   endIcon={<ArrowUpward />}
//                   onClick={() => navigate('/upgrade')}
//                   sx={{ borderRadius: 8 }}
//                 >
//                   Upgrade Now
//                 </Button>
//               </CardContent>
//             </Card>
//           ) : (
//             <Box>
//               <GenderSection>
//                 <Typography variant="h6" align="center" gutterBottom>
//                   Select Age Group
//                 </Typography>
//                 <Stack 
//                   direction="row" 
//                   spacing={1} 
//                   justifyContent="center" 
//                   flexWrap="wrap"
//                   sx={{ mb: 4 }}
//                 >
//                   {ageGroups.map((group) => (
//                     <AgeGroupButton
//                       key={group.label}
//                       selected={selectedAgeGroup === group.label}
//                       onClick={() => handleAgeGroupSelect(group)}
//                     >
//                       {group.label}
//                     </AgeGroupButton>
//                   ))}
//                 </Stack>

//                 <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 4 }}>
//                   {/* Men Section */}
//                   <Box>
//                     <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 3 }}>
//                       <ManRounded sx={{ color: 'primary.main', fontSize: 28 }} />
//                       <Typography variant="h5" sx={{ fontWeight: 600 }}>
//                         Men
//                       </Typography>
//                     </Box>
//                     {loading.male ? (
//                       <Box display="flex" justifyContent="center" p={4}>
//                         <CircularProgress />
//                       </Box>
//                     ) : matches.male.length > 0 ? (
//                       <Fade in timeout={500}>
//                         <Box>
//                           <Typography variant="h6" align="center" gutterBottom color="primary">
//                             {matches.male.length} Matches Found
//                           </Typography>
//                           <MatchesList matches={matches.male} />
//                         </Box>
//                       </Fade>
//                     ) : selectedAgeGroup && (
//                       <Typography 
//                         variant="body1" 
//                         align="center" 
//                         color="text.secondary"
//                         sx={{ py: 4 }}
//                       >
//                         No matches found in this age group.
//                       </Typography>
//                     )}
//                   </Box>

//                   {/* Women Section */}
//                   <Box>
//                     <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 3 }}>
//                       <WomanRounded sx={{ color: 'secondary.main', fontSize: 28 }} />
//                       <Typography variant="h5" sx={{ fontWeight: 600 }}>
//                         Women
//                       </Typography>
//                     </Box>
//                     {loading.female ? (
//                       <Box display="flex" justifyContent="center" p={4}>
//                         <CircularProgress />
//                       </Box>
//                     ) : matches.female.length > 0 ? (
//                       <Fade in timeout={500}>
//                         <Box>
//                           <Typography variant="h6" align="center" gutterBottom color="secondary">
//                             {matches.female.length} Matches Found
//                           </Typography>
//                           <MatchesList matches={matches.female} />
//                         </Box>
//                       </Fade>
//                     ) : selectedAgeGroup && (
//                       <Typography 
//                         variant="body1" 
//                         align="center" 
//                         color="text.secondary"
//                         sx={{ py: 4 }}
//                       >
//                         No matches found in this age group.
//                       </Typography>
//                     )}
//                   </Box>
//                 </Box>
//               </GenderSection>
//             </Box>
//           )}
//         </StyledPaper>
//       </Fade>

//       <Dialog 
//         open={showUpgradeDialog} 
//         onClose={() => setShowUpgradeDialog(false)}
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             p: 2
//           }
//         }}
//       >
//         <DialogTitle sx={{ textAlign: 'center' }}>
//           <Favorite sx={{ fontSize: 40, color: theme.palette.error.light, mb: 1 }} />
//           <Typography variant="h5">Premium Feature</Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Typography align="center">
//             Finding matches is a premium feature. Upgrade your account to access our advanced matching system.
//           </Typography>
//         </DialogContent>
//         <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
//           <Button 
//             onClick={() => { setShowUpgradeDialog(false); setUpgradeModalOpen(true); }}
//             variant="contained" 
//             color="primary"
//             sx={{ borderRadius: 8, px: 4 }}
//           >
//             Upgrade Account
//           </Button>
//           <Button 
//             onClick={() => setShowUpgradeDialog(false)}
//             variant="outlined"
//             sx={{ borderRadius: 8, px: 4 }}
//           >
//             Maybe Later
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <UpgradeModal
//         open={upgradeModalOpen}
//         onClose={() => setUpgradeModalOpen(false)}
//         featureLabel="Find Matches"
//       />
//     </Box>
//   );
// };

// export default FindPartner;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';
import MatchesList from './MatchesList';
import UpgradeModal from '../components/UpgradeModal';
import useAccess from '../hooks/useAccess';
import { useNavigate } from 'react-router-dom'; // ✅ FIX ADDED

import { 
  Paper, 
  Box, 
  Typography, 
  Button, 
  Stack, 
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fade,
  Card,
  CardContent,
  useTheme,
  alpha
} from '@mui/material';

import {
  WomanRounded,
  ManRounded,
  Favorite,
  ArrowUpward
} from '@mui/icons-material';

import { styled } from '@mui/material/styles';

// Styled Components
const StyledPaper = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(4),
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
}));

const AgeGroupButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: theme.spacing(4),
  padding: theme.spacing(1, 3),
  transition: 'all 0.3s ease',
  margin: theme.spacing(0.5),
  backgroundColor: selected ? theme.palette.primary.main : 'transparent',
  color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
  border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
  '&:hover': {
    transform: 'translateY(-2px)',
    backgroundColor: selected ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.1),
  },
}));

const GenderSection = styled(Box)(({ theme }) => ({
  background: alpha(theme.palette.background.paper, 0.6),
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
  },
}));

const FindPartner = () => {
  const theme = useTheme();
  const navigate = useNavigate(); // ✅ FIX ADDED

  const { role, isPremium, loading: accessLoading } = useAccess();

  const [selectedAgeGroup, setSelectedAgeGroup] = useState('');
  const [matches, setMatches] = useState({ male: [], female: [] });
  const [loading, setLoading] = useState({ male: false, female: false });
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  const [remainingSearches, setRemainingSearches] = useState(null);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  const userRole = role == null ? null : Number(role);

  const ageGroups = [
    { label: '18-22', min: 18, max: 22 },
    { label: '23-26', min: 23, max: 26 },
    { label: '27-31', min: 27, max: 31 },
    { label: '32-36', min: 32, max: 36 },
    { label: '37-41', min: 37, max: 41 },
    { label: '42-80', min: 42, max: 80 },
  ];

  const fetchRemainingSearches = async (uid) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/user/remaining-searches`, {
        params: { uid },
        withCredentials: true
      });
      setRemainingSearches(3 - response.data.searchCount);
    } catch (error) {
      console.error('Error fetching remaining searches:', error);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        const userUid = localStorage.getItem('uid');
        if (!userUid) {
          window.location.href = './login';
          return;
        }
        await fetchRemainingSearches(userUid);
      } catch (error) {
        console.error('Failed:', error);
        if (error.response?.status === 401) {
          window.location.href = './login';
        }
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (accessLoading) return;
    if (remainingSearches == null) return;

    if (!isPremium && remainingSearches <= 0 && userRole !== 1) {
      setShowUpgradeDialog(true);
    }
  }, [accessLoading, isPremium, remainingSearches, userRole]);

  const searchMatches = async (gender, ageGroup) => {
    const userUid = localStorage.getItem('uid');
    await fetchRemainingSearches(userUid);

    if (!isPremium && remainingSearches <= 0 && userRole !== 1) {
      setShowUpgradeDialog(true);
      return;
    }

    setLoading(prev => ({ ...prev, [gender.toLowerCase()]: true }));

    try {
      const response = await axios.get(`${API_BASE_URL}/find-match`, {
        params: {
          gender: gender === 'Male' ? 'Male' : 'Female',
          minAge: ageGroup.min,
          maxAge: ageGroup.max
        },
        withCredentials: true
      });

      setMatches(prev => ({
        ...prev,
        [gender.toLowerCase()]: response.data
      }));

    } catch (error) {
      console.error('Error fetching matches:', error);
      if (error.response?.status === 401) {
        window.location.href = './login';
      }
    }

    setLoading(prev => ({ ...prev, [gender.toLowerCase()]: false }));
  };

  const handleAgeGroupSelect = (group) => {
    setSelectedAgeGroup(group.label);

    if (userRole === 0 && !isPremium && remainingSearches === 0) {
      setShowUpgradeDialog(true);
      return;
    }

    searchMatches('Male', group);
    searchMatches('Female', group);
  };

  return (
    <Box>
      <Fade in timeout={1000}>
        <StyledPaper>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="h4" gutterBottom sx={{
              fontWeight: 700,
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
            }}>
              Find Your Perfect Match
            </Typography>

            <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
              Discover compatible partners in your preferred age group
            </Typography>

            {userRole === 0 && !isPremium && (
              <Typography variant="body2" sx={{ mb: 2 }}>
                {remainingSearches > 0
                  ? `Searches remaining: ${remainingSearches}`
                  : 'You have used all your free searches'}
              </Typography>
            )}

            {(userRole === 0 || userRole === 2) && (
              <Typography variant="body2" sx={{ mb: 2 }}>
                {!isPremium
                  ? 'Upgrade your account to find matches'
                  : `Subscription Status: Premium`}
              </Typography>
            )}
          </Box>

          {(userRole === 0 || userRole === 2) && !isPremium && remainingSearches === 0 ? (
            <Card sx={{ maxWidth: 400, mx: 'auto', textAlign: 'center' }}>
              <CardContent>
                <Favorite sx={{ fontSize: 60, color: theme.palette.error.light, mb: 2 }} />

                <Typography variant="h5" gutterBottom>
                  Premium Feature
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  Upgrade your account to continue.
                </Typography>

                <Button
                  variant="contained"
                  endIcon={<ArrowUpward />}
                  onClick={() => navigate('/upgrade')} // ✅ FIX WORKS NOW
                >
                  Upgrade Now
                </Button>
              </CardContent>
            </Card>
          ) : (
            <Box>
              <GenderSection>
                <Typography variant="h6" align="center">Select Age Group</Typography>

                <Stack direction="row" spacing={1} justifyContent="center" flexWrap="wrap" sx={{ mb: 4 }}>
                  {ageGroups.map(group => (
                    <AgeGroupButton
                      key={group.label}
                      selected={selectedAgeGroup === group.label}
                      onClick={() => handleAgeGroupSelect(group)}
                    >
                      {group.label}
                    </AgeGroupButton>
                  ))}
                </Stack>

                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 4 }}>
                  {/* Men */}
                  <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 3 }}>
                      <ManRounded />
                      <Typography variant="h5">Men</Typography>
                    </Box>

                    {loading.male ? (
                      <CircularProgress />
                    ) : matches.male.length > 0 ? (
                      <MatchesList matches={matches.male} />
                    ) : selectedAgeGroup && (
                      <Typography>No matches found.</Typography>
                    )}
                  </Box>

                  {/* Women */}
                  <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 3 }}>
                      <WomanRounded />
                      <Typography variant="h5">Women</Typography>
                    </Box>

                    {loading.female ? (
                      <CircularProgress />
                    ) : matches.female.length > 0 ? (
                      <MatchesList matches={matches.female} />
                    ) : selectedAgeGroup && (
                      <Typography>No matches found.</Typography>
                    )}
                  </Box>
                </Box>
              </GenderSection>
            </Box>
          )}
        </StyledPaper>
      </Fade>

      {/* Upgrade Dialog */}
      <Dialog open={showUpgradeDialog} onClose={() => setShowUpgradeDialog(false)}>
        <DialogTitle>Premium Feature</DialogTitle>
        <DialogContent>
          Upgrade required to continue searching.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setShowUpgradeDialog(false); setUpgradeModalOpen(true); }}>
            Upgrade
          </Button>
          <Button onClick={() => setShowUpgradeDialog(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <UpgradeModal
        open={upgradeModalOpen}
        onClose={() => setUpgradeModalOpen(false)}
        featureLabel="Find Matches"
      />
    </Box>
  );
};

export default FindPartner;